function FlickrEmbed({ html }) {
  return <div className="flickr__container" dangerouslySetInnerHTML={{ __html: html }}></div>;
}

export default FlickrEmbed;
